module.exports = __webpack_public_path__ + "img/CHAU WEI JIUE.92ba639e.svg";